// extracted by mini-css-extract-plugin
export default {"defaultLink":"defaultLink__bhLmP","active":"active__1Ph8J","openedMenu":"openedMenu__3YHr1","icon":"icon__3NYu4"};